// Supporting infrastructure: "App / Window Registration" from the
// engineering handoff. This is the canonical list of app windows the
// Desktop system knows about. Adding a new app window later (per the
// handoff's invariant) should mean adding an entry here - not touching
// ShellAppWindow, WindowManagerSurface, or the Desktop State Manager.
//
// id             - matches the "Window id" prop set on a ShellAppWindow
//                   instance in Plasmic, and the "Window id" prop set on
//                   the AppWindowButton that opens it.
// title          - fallback title shown in ShellAppWindow's title bar if
//                   no override is set on the instance.
// defaultWidth/Height/X/Y - initial size/position the first time a window
//                   is opened. After that, its position/size in the
//                   current session is whatever the user last left it at.
const windowRegistry = {
  conversations: {
    id: "conversations",
    title: "Conversations",
    defaultWidth: 480,
    defaultHeight: 560,
    defaultX: 80,
    defaultY: 80,
  },
  notes: {
    id: "notes",
    title: "Notes",
    defaultWidth: 420,
    defaultHeight: 520,
    defaultX: 560,
    defaultY: 140,
  },
  textTest: {
    id: "textTest",
    title: "Text-Triggered Window",
    defaultWidth: 420,
    defaultHeight: 360,
    defaultX: 320,
    defaultY: 260,
  },
  // Pilot window for the frame-style code component (OP1WebFrameWindow).
  // Separate id so it never collides with the existing windows.
  framePilot: {
    id: "framePilot",
    title: "Frame Pilot",
    defaultWidth: 420,
    defaultHeight: 360,
    defaultX: 200,
    defaultY: 120,
  },
  // Test window for the Plasmic-designed OP1WebAW (+ OP1WebAWButton).
  // Width matches the design (468px); height is ~80dvh of a typical screen.
  PlasmicWindow: {
    id: "PlasmicWindow",
    title: "Plasmic Window",
    defaultWidth: 468,
    defaultHeight: 600,
    defaultX: 240,
    defaultY: 60,
  },
};

export default windowRegistry;

// Background Space System: which Plasmic page occupies the background
// layer. Switching spaces must never affect Desktop/window state (see
// handoff invariants) - SpaceDockButton only ever touches `currentSpace`.
export const spaceRegistry = {
  members: {
    id: "members",
    title: "Members",
  },
  forum: {
    id: "forum",
    title: "Forum",
  },
};
